import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ContractClientHistory.List.IRequest;
type Response = Api.Core.ContractClientHistory.List.IResponse;
type Headers = Api.Core.ContractClientHistory.List.IHeaders;
const url = '/api/Sales/ContractClientHistory';
export default async function contractClientHistoryListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
